import React from 'react';

// components
import ChatBubble from 'eCoach/ChatBubble';
import DocumentList from 'documentDisplay/components/DocumentList';
import DocumentListWithFormOption from 'documentDisplay/components/DocumentListWithFormOption';
import StyledMarkdown from 'shared/StyledMarkdown';

// types
import { UserInputType } from 'eCoach/utils';
import { DocumentTranslation } from 'types/document';

export interface RAGOutputWithFormOption {
  rag: {
    summary: string;
    document_translations: DocumentTranslation[];
    has_fillable_forms?: boolean;
  };
}

interface RAGCardWithFormOptionProps {
  output: RAGOutputWithFormOption;
  sendUserInput: (
    message: string,
    inputType: number,
    extraData?: Record<string, any>
  ) => void;
}

export default function RAGCardWithFormOption({
  output,
  sendUserInput,
}: RAGCardWithFormOptionProps): JSX.Element {
  const handleFillForm = (documentTranslation: DocumentTranslation) => {
    if (documentTranslation.form_template_id) {
      sendUserInput(
        documentTranslation.title,
        UserInputType.FORM_TEMPLATE_CHOICE,
        { form_template_id: documentTranslation.form_template_id }
      );
    }
  };

  // Check if any documents have form templates
  const hasFormTemplates = output.rag.document_translations.some(
    (doc) => doc.has_form_template
  );

  return (
    <ChatBubble>
      <StyledMarkdown content={output.rag.summary} />
      {output.rag.document_translations.length > 0 && (
        <>
          {hasFormTemplates ? (
            <DocumentListWithFormOption
              documentList={output.rag.document_translations}
              onFillForm={handleFillForm}
            />
          ) : (
            <DocumentList documentList={output.rag.document_translations} />
          )}
        </>
      )}
    </ChatBubble>
  );
}
